import { render, staticRenderFns } from "./BtnExcluirDotacao.vue?vue&type=template&id=1bf51f2c"
import script from "./BtnExcluirDotacao.vue?vue&type=script&lang=js"
export * from "./BtnExcluirDotacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports